import { useContext, useEffect, useState } from 'react'
import { UiContext } from '../context/UiContext'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage';

export const useHideMenu = ( ocultar ) => {

    const { showMenu, hideMenu } = useContext( UiContext );
    let [usuario] = useState( getUsuarioStorage() );

    useEffect(() => {
        
        
        if(usuario.uidUsuario=== null) hideMenu();
        else {
            ocultar ? hideMenu() : showMenu();
        }
        
        
        

    }, [ ocultar, hideMenu, showMenu ])

}
